import React, {useState} from 'react';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import {
    Button,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ThemeProvider
} from "@mui/material";

import {ROUTES} from "../../../routes/Routes";
import {THEME} from "../../../theme/PacsTheme";

export default function NavBarResponsive(props) {

    const setSelected = props.setSelected;

    const [drawer, setDrawer] = useState(false);

    const handleClick = (obj) => {
        setDrawer(true);
    }

    const handleSelection = (obj) => {

        setSelected(obj);
        setDrawer(false);
    }

    return (
        <React.Fragment>

            <div
                style={{
                    textAlign: "right",
                    marginRight: "10px",
                    position: "relative",
                    top: "-180px",
                    marginTop: "-60px"
                }}
                >
                <ThemeProvider theme={THEME}>
                    <Button onClick={handleClick}>
                        <MoreVertIcon color={"primary"} style={{
                            transform: "scale(1.4)"
                        }}/>
                    </Button>
                </ThemeProvider>
            </div>

            <Drawer
                open={drawer}
                onClose={(obj) => setDrawer(false)}
                anchor={"bottom"}
            >
                <List>
                    {
                        ROUTES.map((route, index) => (

                            <ListItem key={route.title} disablePadding>
                                <ListItemButton onClick={() => handleSelection(route.route)}>
                                    <ListItemIcon>
                                        {route.icon}
                                    </ListItemIcon>
                                    <ListItemText secondary={route.title}/>
                                </ListItemButton>
                            </ListItem>
                        ))
                    }
                </List>
            </Drawer>

        </React.Fragment>
    )
}